// Converts a UTC timestamp string to local format: "DD.MM.YYYY HH:mm"
export function convertUTCToLocal(utcString) {
  if (!utcString) return "";
  const date = new Date(utcString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

// Formats a date for API queries, setting start to "00:00:00" and end to "23:59:59" when flagged
export function formatDateTimeForAPI(dateTime, isEndDate = false) {
  if (!dateTime) return "";
  const date = new Date(dateTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = isEndDate ? "23" : "00";
  const minutes = isEndDate ? "59" : "00";
  const seconds = isEndDate ? "59" : "00";
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

// Computes a slight offset for marker positioning to avoid overlap when multiple points share the same coords
export function getOffsetPosition(center, index, total, radius = 0.0001) {
  if (total <= 1) return center;
  const angle = (2 * Math.PI * index) / total;
  return {
    lat: center.lat + radius * Math.cos(angle),
    lng: center.lng + radius * Math.sin(angle),
  };
}

// --------------------------
// Usage in DocumentsPage.jsx

// 1. Remove the inline helper definitions (convertUTCToLocal, formatDateTimeForAPI, getOffsetPosition)
// 2. At the top of the file, add:
//
// import { convertUTCToLocal, formatDateTimeForAPI, getOffsetPosition } from '@/lib/utils/dateUtils';
//
// The rest of your component can now call these functions as before, but imported from the shared utility file.
